import NumberedList from '@/screensComponents/FinancialServices/NumberedList/NumberedList'
import { TableBlock } from '@/screensComponents/Insurances/TableBlock/TableBlock'
import { gridInfo } from '@/screensComponents/Insurances/TableBlock/TableData'

import { HeroBannerInfo } from '@/widgets/HeroBannerInfo'

import { FaqSection } from '@/shared/ui/FaqSection'
import { HorizontalSection } from '@/shared/ui/HorizontalSection'
import { PdfList } from '@/shared/ui/PdfList'

import { faqItemsFiz, heroBannerInfoData, pdfListFiz, stepsItemsFiz } from './data'

import cl from './styles.module.scss'

export const Insurance = () => {
	return (
		<>
			<HeroBannerInfo {...heroBannerInfoData} />
			<NumberedList data={stepsItemsFiz} className={cl.mb} />
			<TableBlock {...gridInfo} />
			<HorizontalSection title="Частые вопросы" borderNone>
				<FaqSection items={faqItemsFiz} />
			</HorizontalSection>
			<PdfList items={pdfListFiz} />
		</>
	)
}
